import { faArrowUp } from "@fortawesome/pro-regular-svg-icons";
import { faArrowDown } from "@fortawesome/pro-solid-svg-icons/faArrowDown";
import { Box } from "@mui/material";
import { DataGridPremium, DataGridPremiumProps } from "@mui/x-data-grid-premium";
import { LicenseInfo } from "@mui/x-license";
import { ConfigService } from "@shuttlerock/configuration";
import { ReactElement } from "react";
import { FaIcon } from "../Icon/FaIcon";

const muiXLicenseKey = ConfigService.MUI_X_LICENSE_KEY() as string;
LicenseInfo.setLicenseKey(muiXLicenseKey);

export type SrDataGridProps = DataGridPremiumProps;

export function SrDataGrid({
  autoHeight = true,
  slots,
  sx,
  ...props
}: SrDataGridProps): ReactElement {
  return (
    <Box sx={{ width: "100%", height: autoHeight ? undefined : 1 }}>
      <DataGridPremium
        columnBufferPx={1500}
        rowHeight={80}
        disableColumnMenu
        autoHeight={autoHeight}
        ignoreValueFormatterDuringExport
        cellSelection
        slots={{
          ...baseSlots,
          ...slots,
        }}
        sx={[
          {
            ".MuiDataGrid-cell.Mui-error": {
              borderColor: "error.main",
            },
            ".MuiDataGrid-cell.Mui-disabled": {
              color: "grey.500",
            },
            ".required": {
              color: "error.main",
            },
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...props}
      />
    </Box>
  );
}

const baseSlots = {
  columnSortedAscendingIcon: GridSortAscendingIcon,
  columnSortedDescendingIcon: GridSortDescendingIcon,
  columnUnsortedIcon: GridSortAscendingIcon,
};

function GridSortAscendingIcon() {
  return <FaIcon icon={faArrowUp} sx={{ fontSize: 8, color: "fg.600" }} />;
}

function GridSortDescendingIcon() {
  return <FaIcon icon={faArrowDown} sx={{ fontSize: 8, color: "fg.600" }} />;
}
